// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/clipboard-check.js';

import { paths } from '../generated/clipboard-check';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('clipboard-check', Original, paths);
